/**
 * 获取当前前端版本信息
 */
export function getVersion(): string {
    if (import.meta.env.VITE_IS_QN) {
        // 这里是使用 vite 注入的 version
        return import.meta.env.VITE_SE_VERSION;
    } else if (import.meta.env.DEV) {
        return "DEV";
    } else {
        // public 下的 html 注入的 version
        return window["_SE_VERSION_"];
    }
}
